// React dependencies
import React, { useState, useEffect } from "react";

// Styling
import styles from './PrintPage.module.css'

const PrintPageSinglePrint = ({
    registrant, // array of registrants
    registrantPrintSettings, // cssvalues, specialcssrules, fieldordering
    badgeDimensions, // print badge height and width
    badgeOrientations, // print badge margin, padding, alignment, display, position
    componentRef, // print component
}) => {

    // Constants
    const combinedStyles = { ...badgeDimensions, ...badgeOrientations }
    const CSSValues = registrantPrintSettings.cSSValues
    const specialCSSRules = registrantPrintSettings.specialCSSRules
    const fieldOrdering = registrantPrintSettings.fieldOrdering
    const stylingForm = registrant

    const toLowerCamelCase = str => {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

    // Helper function to retrieve and style field content
    const getFieldContent = (cssFieldName, specialCSSRules, stylingForm, CSSValues) => {
        let lowerCamelCaseString = toLowerCamelCase(cssFieldName)

        const formValue1 = stylingForm[0][cssFieldName] ? stylingForm[0][cssFieldName] : "" // Input form value - PascalCase
        const formValue2 = stylingForm[0][lowerCamelCaseString] ? stylingForm[0][lowerCamelCaseString] : "" // Input form value - camelCase

        let fieldName = formValue1 ? formValue1 : formValue2 ? formValue2 : ""

        // only display fields that are "fully configured"
        if (!CSSValues[cssFieldName] && cssFieldName !== "ScannerField") {
            return null
        }

        if (!cssFieldName.toLowerCase().includes("scannerfield") && !cssFieldName.toLowerCase().includes("image")) {

            const specialCssSmaller = specialCSSRules?.[`${cssFieldName}Smaller`] // SpecialCSSRules Smaller
            const specialCssSmallest = specialCSSRules?.[`${cssFieldName}Smallest`] // SpecialCSSRules Smallest

            const cssNormal = CSSValues[cssFieldName] // Normal CSS (no special CSS rules applied)
            const cssSmaller = CSSValues[`${cssFieldName}Smaller`] // .Smaller CSS class
            const cssSmallest = CSSValues[`${cssFieldName}Smallest`] // .Smallest CSS class

            const defaultStyle = { fontSize: "24px", fontFamily: "Nunito Sans", margin: "0 0 5px 0", padding: "0" };
            let style = {}

            if (formValue1 && formValue1.length) {
                style =
                    specialCssSmallest?.active &&
                        formValue1.length && (formValue1.length > specialCssSmallest.length)
                        ? cssSmallest
                        : specialCssSmaller?.active &&
                            formValue1.length && (formValue1.length > specialCssSmaller.length)
                            ? cssSmaller
                            : cssNormal  
            }
            else {
                style =
                    specialCssSmallest?.active &&
                        formValue2.length && (formValue2.length > specialCssSmallest.length)
                        ? cssSmallest
                        : specialCssSmaller?.active &&
                            formValue2.length && (formValue2.length > specialCssSmaller.length)
                            ? cssSmaller
                            : cssNormal
            }

            return <p style={style || defaultStyle}>{fieldName}</p>;
        }
        else {
            const imageFields = [
                "ScannerField", "Image01", "Image02", "Image03", "Image04",
                "Image05", "Image06", "Image07", "Image08", "Image09", "Image10"
            ];

            return imageFields.map((field) => {
                const imageCSS = CSSValues[field] && CSSValues[field] !== "" ? CSSValues[field] :
                    { width: "200px", height: "0px", margin: "0", padding: "0" };

                const imageFile = stylingForm[0][field];

                return imageFile ? (
                    <img key={field} style={imageCSS} src={imageFile} alt={field} />
                ) : (
                    <p key={field} style={imageCSS}>{stylingForm[field]}</p>
                );
            });
        }
    }

    const renderSwitch = (field) => {

        let fieldName = field.cssFieldName

        switch (fieldName) {
            case "ScannerField":
            case "ScannerImage":
            case "FirstName":
            case "LastName":
            case "FullName_Combo":
            case "LastNameFirstName_Combo":
            case "Organization":
            case "RegistrationType":
            case "Title":
            case "City":
            case "State":
            case "Country":
            case "Credentials":
            case "Pronouns":
            case "RegistrationColor":
            case "Prefix":
            case "Suffix":
            case "Salutation":
            case "DiscountCode":
            case "EmailAddress":
            case "MemberType":
            case "Designation":
            case "Industry":
            case "Gender":
            case "Category":
            case "Ribbon":
            case "Region":
            case "Department":
            case "StaticField01":
            case "StaticField02":
            case "StaticField03":
            case "StaticField04":
            case "StaticField05":
            case "StaticField06":
            case "StaticField07":
            case "StaticField08":
            case "StaticField09":
            case "StaticField10":
            case "CityState_Combo":
                return getFieldContent(field.cssFieldName, specialCSSRules, stylingForm, CSSValues)

            default:
                return null
        }
    }

    return (
        <div className={styles.badgeContainer} style={combinedStyles } ref={componentRef}>
            {fieldOrdering.map((field, index) => (renderSwitch(field)))}
        </div>
    )
}

export default PrintPageSinglePrint;